<div class="container-fluid padding-top">
  <div *ngIf="isProd"
       class="row d-flex flex-column flex-sm-row flex-wrap justify-content-center">
    <div class="col-sm-4">
      <md-card class="stat-block text-center mb-5">
        <h3><b>Total Clients</b></h3>
        <h1 *ngIf="totalClients; else loading">{{ totalClients }}</h1>
      </md-card>
    </div>

    <div class="col-sm-4">
      <md-card class="stat-block text-center mb-5">
        <h3><b>Total Locations</b></h3>
        <h1 *ngIf="totalLocations; else loading">{{ totalLocations }}</h1>
      </md-card>
    </div>

    <div class="col-sm-4">
      <md-card class="stat-block text-center mb-5">
        <h3><b>Units Rented</b></h3>
        <h1 *ngIf="unitsRented; else loading">{{ unitsRented }}</h1>
      </md-card>
    </div>

    <div class="col-sm-4">
      <md-card class="stat-block text-center mb-5">
        <h3><b>Units Reserved</b></h3>
        <h1 *ngIf="unitsReserved; else loading">{{ unitsReserved }}</h1>
      </md-card>
    </div>

    <div class="col-sm-4">
      <md-card class="stat-block text-center mb-5">
        <h3><b>Payments Taken</b></h3>
        <h1 *ngIf="payments; else loading">{{ payments.totalPayments }}</h1>
      </md-card>
    </div>

    <div class="col-sm-4">
      <md-card class="stat-block text-center mb-5">
        <h3><b>Payments Amount</b></h3>
        <h1 *ngIf="payments; else loading">{{ payments.totalAmount | currency:'USD':'symbol-narrow':'.2-2' }}</h1>
      </md-card>
    </div>
  </div>


  <md-card>
    <div class="row">
      <div class="col-md-12">
        <h2>Clients
          <button class="btn btn-secondary float-right"
                  (click)="updateSettingsOnServer()">Update all client settings</button>
        </h2>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">

        <div class="ui-widget-header"
             style="padding:4px 10px;border-bottom: 0 none">
          <i class="fa fa-search"
             style="margin:4px 4px 0 0"></i>
          <input #gb
                 id="global-filter"
                 [(ngModel)]="tableService.filter"
                 (keyup)="onFilterKeyUp($event)"
                 type="text"
                 pInputText
                 placeholder="Search"
                 style="width: 250px !important;">
        </div>
        <p-dataTable [value]="tableFacilities"
                     [sortField]="tableService.sortField"
                     [sortOrder]="tableService.sortOrder"
                     class="text-center"
                     selectionMode="single"
                     (onRowSelect)="onRowSelect($event)"
                     (onSort)="tableService.listen($event, 'sort')"
                     (onPage)="tableService.listen($event, 'page')"
                     (onFilter)="tableService.listen($event, 'filter')"
                     [rows]="tableService.numRows"
                     [rowsPerPageOptions]="[10,25,50,100,250]"
                     [responsive]="true"
                     [paginator]="true"
                     [globalFilter]="gb"
                     [loading]="isTableLoading"
                     #dt>
          <p-column field="logoUrl"
                    header="Logo">
            <ng-template let-col
                         let-car="rowData"
                         pTemplate="body">
              <span><img class="facility-logo"
                     [src]="car[col.field]"
                     alt=""></span>
            </ng-template>
          </p-column>
          <p-column field="name"
                    header="Name"
                    [sortable]="true"></p-column>
          <p-column field="propertySoftware"
                    header="Software"
                    [sortable]="true"></p-column>
          <p-column field="deployedVersion"
                    header="Deployed Version"
                    [sortable]="true"></p-column>
          <p-column field="deployedCommit"
                    header="Deployed Commit"
                    [sortable]="true"></p-column>
          <p-column field="dateLastDeployed"
                    header="Date Last Deployed"
                    [sortable]="'custom'"
                    (sortFunction)="sortTableByDate($event)"></p-column>
          <p-column field="code"
                    header="Client Code"
                    [sortable]="true"></p-column>
          <p-column field="$key"
                    header="">
            <ng-template let-col
                         let-car="rowData"
                         pTemplate="body">
              <button class="btn btn-accent btn-lg btn-block"
                      [routerLink]="['/clients/'+car[col.field]]">View</button>
            </ng-template>
          </p-column>
          <p-footer>
            <div class="ui-helper-clearfix"
                 style="width:100%">
              <button type="button"
                      class="btn btn-primary"
                      style="float:left"
                      (click)="showDialogToAdd()">
                <i class="fa fa-plus"
                   aria-hidden="true"></i> Add
              </button>
            </div>
          </p-footer>
        </p-dataTable>

        <p-dialog header="Client Details"
                  [(visible)]="displayDialog"
                  [responsive]="true"
                  [width]="600"
                  [resizable]="true"
                  showEffect="fade"
                  [modal]="true"
                  [dismissableMask]="true"
                  [positionTop]="50">
          <div class="ui-grid ui-grid-responsive ui-fluid"
               *ngIf="client">
            <div class="row sm-padding-top">
              <div class="col-md-6">
                <label for="name">Name</label>
                <input pInputText
                       id="name"
                       [(ngModel)]="client.name" />
              </div>
              <div class="col-md-6">
                <label for="tagLine">Tag Line</label>
                <input pInputText
                       id="tagLine"
                       [(ngModel)]="client.tagLine" />
              </div>
            </div>
            <div class="row sm-padding-top">
              <div class="col-md-6">
                <label for="code">Client Code</label>
                <input *ngIf="isNew"
                       pInputText
                       id="code"
                       [(ngModel)]="client.code" />
                <input *ngIf="!isNew"
                       [disabled]="true"
                       pInputText
                       id="code"
                       [(ngModel)]="client.code" />
              </div>
              <div class="col-md-6">
                <label *ngIf="client.siteUrl; else noSiteUrl"
                       for="siteUrl">
                  <a [style.color]="'#337ab7'"
                     [style.text-decoration]="'underline'"
                     [href]="client.siteUrl"
                     target="_blank"
                     rel="noopener">
                    Website Url
                  </a>
                </label>
                <ng-template #noSiteUrl>
                  <label for="siteUrl">Website Url</label>
                </ng-template>
                <input pInputText
                       id="siteUrl"
                       [(ngModel)]="client.siteUrl" />

                <label *ngIf="client.hubspotCompanyId; else noHubspotId"
                       for="hubspotCompanyId">
                  <a [style.color]="'#337ab7'"
                     [style.text-decoration]="'underline'"
                     [href]="'https://app.hubspot.com/contacts/3852224/company/'+client.hubspotCompanyId"
                     target="_blank"
                     rel="noopener">
                    Hubspot Company ID
                  </a>
                </label>
                <ng-template #noHubspotId>
                  <label for="hubspotCompanyId">Hubspot Company ID</label>
                </ng-template>

                <input type="number"
                       pInputText
                       id="hubspotCompanyId"
                       class="full-width"
                       [(ngModel)]="client.hubspotCompanyId" />

              </div>
            </div>

            <div class="row sm-padding-top">
              <div class="col-md-3">
                <label for="logoUrl">Logo URL</label>
              </div>
              <div class="col-md-9">
                <input pInputText
                       id="logoUrl"
                       [(ngModel)]="client.logoUrl" />
              </div>
            </div>
            <div class="row sm-padding-top">
              <div class="col-md-3"
                   *ngIf="client.propertySoftware == 'sitelink'">
                <label for="pushRateThreshHold">Push Rate Threshold</label>
              </div>
              <div class="col-md-3"
                   *ngIf="client.propertySoftware == 'sitelink'">
                <p-spinner [min]="0"
                           id="pushRateThreshHold"
                           [(ngModel)]="client.pushRateThreshold"></p-spinner>
              </div>
              <div class="col-md-3">
                <label for="numUnitsToShowUnitNumberLeft">Show Units left Threshold</label>
              </div>
              <div class="col-md-3">
                <p-spinner [min]="0"
                           id="numUnitsToShowUnitNumberLeft"
                           [(ngModel)]="client.numUnitsToShowUnitNumberLeft"></p-spinner>
              </div>
              <div class="col-md-3"
                   *ngIf="client.propertySoftware == 'none'">
                <md-slide-toggle [(ngModel)]="client.suppressGetUnits">
                  Suppress get units API call
                </md-slide-toggle>
              </div>
            </div>
            <div class="row sm-padding-top">
              <div class="col-md-4">
                <label>Property Software</label>
              </div>
              <div class="col-md-8">
                <p-dropdown [options]="softwareIntegrations.data"
                            [(ngModel)]="client.propertySoftware"
                            [autoWidth]="false"
                            name="ccType"
                            [placeholder]="'Select'"
                            class="full-width"></p-dropdown>
              </div>
            </div>
            <div [hidden]="client.propertySoftware !== 'storage-commander'"
                 class="row sm-padding-top">
              <div class="col-md-4">
                <label>Storage Commander loc id</label>
              </div>
              <div class="col-md-8">
                <input pInputText
                       id="storageCommanderLocId"
                       [(ngModel)]="client.storageCommanderLocId" />
              </div>
            </div>
            <div class="row sm-padding-top">
              <div class="col-md-3">
                <label for="reCaptchaSiteKey">reCaptcha Site Key</label>
              </div>
              <div class="col-md-9">
                <input pInputText
                       id="reCaptchaSiteKey"
                       [(ngModel)]="client.reCaptchaSiteKey" />
              </div>
            </div>
            <div class="row sm-padding-top">
              <div class="col-md-12">
                <button class="btn btn-primary"
                        color="primary"
                        (click)="fillreCaptchaDemoDetails()">Fill reCaptcha Demo</button>
              </div>
            </div>
            <div class="row sm-padding-top">

              <div class="col-md-3">
                <label for="primaryHex">Primary Hex Code</label>
              </div>
              <div class="col-md-3">
                <div class="color-block"
                     [ngStyle]="{'background': client.primaryHex}"></div>
                <p-inputMask id="primaryHex"
                             mask="#******"
                             placeholder="#e3e3e3"
                             [(ngModel)]="client.primaryHex"></p-inputMask>
              </div>
              <div class="col-md-3">
                <label for="accentHex">Accent Hex Code</label>
              </div>
              <div class="col-md-3">
                <div class="color-block"
                     [ngStyle]="{'background': client.accentHex}"></div>
                <p-inputMask id="accentHex"
                             mask="#******"
                             placeholder="#e3e3e3"
                             [(ngModel)]="client.accentHex"></p-inputMask>
              </div>
            </div>
            <div class="row sm-padding-top">
              <h4>Analytics</h4>
            </div>
            <div class="row analytics-card">
              <div class="col-md-6">
                <header class="Box-header">
                  <div class="AccountExplorerSearch">
                    <div id="view-selector-container">
                    </div>
                  </div>
                </header>
              </div>
              <div class="col-md-6 text-center"
                   *ngIf="goog?.selectedAccountAnalyticsId && goog?.selectedAccountViewId"
                   style="">
                <h4>Google Analytics Key</h4>
                <h4 style="font-weight: 300;">{{goog?.selectedAccountAnalyticsId}}</h4>

                <h4>View Id</h4>
                <h4 style="font-weight: 300;">{{goog?.selectedAccountViewId}}</h4>
                <br>
                <button class="btn btn-accent"
                        (click)="setAnalytics()">Set Analytics</button>
              </div>
            </div>
            <div class="row sm-padding-top">
              <div class="col-md-2">
                <label for="analyticsId">Analytics ID</label>
              </div>
              <div class="col-md-4">
                <input pInputText
                       id="analyticsId"
                       placeholder="UA-XXXXX-XX"
                       [(ngModel)]="client.analyticsId" />
              </div>
              <div class="col-md-2">
                <label for="viewId">View ID</label>
              </div>
              <div class="col-md-4">
                <input pInputText
                       id="viewId"
                       placeholder="ga:123456789"
                       [(ngModel)]="client.analyticsViewId" />
              </div>
            </div>
            <hr>
            <br>
            <div class="row sm-padding-top">
              <div class="col-md-6">
                <md-slide-toggle [(ngModel)]="client.rentReserveButtonClick">
                  Rent/Reserve Button Click Adwords Tracking?
                </md-slide-toggle>
              </div>
            </div>
            <div *ngIf="client.rentReserveButtonClick"
                 class="row sm-padding-top">
              <div class="col-md-3">
                <label for="rentReserveButtonClickTrackingCode">Rent/Reserve Button Adwords Tracking Code</label>
              </div>
              <div class="col-md-3">
                <input pInputText
                       id="rentReserveButtonClickTrackingCode"
                       placeholder="AW-CONVERSION_ID/CONVERSION_LABEL"
                       [(ngModel)]="client.rentReserveButtonClickTrackingCode" />
              </div>
            </div>
            <div class="row sm-padding-top">
              <div class="col-md-6">
                <md-slide-toggle [(ngModel)]="client.rentReserveSuccessPageTrack">
                  Rent/Reserve Success Page Adwords Tracking?
                </md-slide-toggle>
              </div>
            </div>
            <div *ngIf="client.rentReserveSuccessPageTrack"
                 class="row sm-padding-top">
              <div class="col-md-3">
                <label for="rentReserveSuccessPageTrackingCode">Rent/Reserve Success Page Adwords Tracking Code</label>
              </div>
              <div class="col-md-3">
                <input pInputText
                       id="rentReserveSuccessPageTrackingCode"
                       placeholder="AW-CONVERSION_ID/CONVERSION_LABEL"
                       [(ngModel)]="client.rentReserveSuccessPageTrackingCode" />
              </div>
            </div>

            <div class="row sm-padding-top">
              <div class="col-md-6">
                <md-slide-toggle [(ngModel)]="client.contactFormSubmitTrack">
                  Contact Form Submit Adwords Tracking?
                </md-slide-toggle>
              </div>
            </div>
            <div *ngIf="client.contactFormSubmitTrack"
                 class="row sm-padding-top">
              <div class="col-md-3">
                <label for="contactFormSubmitTrackingCode">Contact Form Submit Adwords Tracking Code</label>
              </div>
              <div class="col-md-3">
                <input pInputText
                       id="contactFormSubmitTrackingCode"
                       placeholder="AW-CONVERSION_ID/CONVERSION_LABEL"
                       [(ngModel)]="client.contactFormSubmitTrackingCode" />
              </div>
            </div>

            <div class="row sm-padding-top">
              <div class="col-md-6">
                <md-slide-toggle [(ngModel)]="client.instantQuoteSubmitTrack">
                  Instant Quote Form Submit Adwords Tracking?
                </md-slide-toggle>
              </div>
            </div>
            <div *ngIf="client.instantQuoteSubmitTrack"
                 class="row sm-padding-top">
              <div class="col-md-3">
                <label for="instantQuoteSubmitTrackingCode">Instant Quote Form Submit Adwords Tracking Code</label>
              </div>
              <div class="col-md-3">
                <input pInputText
                       id="instantQuoteSubmitTrackingCode"
                       placeholder="AW-CONVERSION_ID/CONVERSION_LABEL"
                       [(ngModel)]="client.instantQuoteSubmitTrackingCode" />
              </div>
            </div>
          </div>

          <p-footer>
            <div class="ui-dialog-buttonpane ui-helper-clearfix">
              <button type="button"
                      class="btn btn-accent"
                      (click)="save()"><i class="fa fa-check"
                   aria-hidden="true"></i> Save</button>
              <button type="button"
                      class="btn btn-primary"
                      (click)="copyToProd()"><i class="fa fa-exclamation-triangle"
                   aria-hidden="true"></i> Copy to {{isProd ? 'Staging' : 'Prod'}}</button>
              <button type="button"
                      class="btn btn-danger"
                      (click)="deleteClient()"><i class="fa fa-trash"
                   aria-hidden="true"></i> Delete</button>
            </div>
          </p-footer>
        </p-dialog>

      </div>
    </div>
  </md-card>

  <md-card class="margin-top margin-bottom">
    <div class="row">
      <div class="col-md-12">
        <md-card-header>
          <md-card-title>
            <h2>Users</h2>
          </md-card-title>
        </md-card-header>
        <div class="ui-widget-header"
             style="padding:4px 10px;border-bottom: 0 none">
          <i class="fa fa-search"
             style="margin:4px 4px 0 0"></i>
          <input #gbUsers
                 type="text"
                 pInputText
                 placeholder="Search"
                 style="width: 250px !important;">
        </div>
        <p-dataTable [value]="(afService.users | async)"
                     sortField="name"
                     class="text-center"
                     selectionMode="single"
                     [(selection)]="selectedClient"
                     (onRowSelect)="onUserRowSelect($event)"
                     [rows]="10"
                     [responsive]="true"
                     [paginator]="true"
                     [globalFilter]="gbUsers"
                     #dt2>
          <p-column field="name"
                    header="Name"
                    [sortable]="true"></p-column>
          <p-column field="accountType"
                    header="Account Type"
                    [sortable]="true">
            <ng-template let-col
                         let-car="rowData"
                         pTemplate="body">
              <md-chip-list>
                <md-chip *ngIf="car[col.field] == 0">Manager</md-chip>
                <md-chip *ngIf="car[col.field] == 1"
                         selected="true"
                         color="accent">Owner</md-chip>
                <md-chip *ngIf="car[col.field] == 2"
                         selected="true"
                         color="warn">Admin</md-chip>
              </md-chip-list>
            </ng-template>
          </p-column>
          <p-column field="email"
                    header="Email"
                    [sortable]="true"></p-column>
          <p-column field="phone"
                    header="Phone"
                    [sortable]="true"></p-column>
          <p-column field="jobTitle"
                    header="Job Title"
                    [sortable]="true"></p-column>
          <p-footer>
            <div class="ui-helper-clearfix"
                 style="width:100%">
              <button type="button"
                      class="btn btn-primary"
                      style="float:left"
                      (click)="showFacilityUserDialogToAdd()">
                <i class="fa fa-plus"
                   aria-hidden="true"></i> Add
              </button>
            </div>
          </p-footer>
        </p-dataTable>

        <p-dialog header="Facility User Details"
                  [(visible)]="displayFacilityUserDialog"
                  [responsive]="true"
                  [width]="600"
                  [resizable]="true"
                  showEffect="fade"
                  [modal]="true"
                  [dismissableMask]="true"
                  [positionTop]="50">
          <div class="ui-grid ui-grid-responsive ui-fluid"
               *ngIf="facilityUser">
            <div *ngIf="error"
                 class="row">
              <div class="col-md-8 col-md-offset-2">
                <div class="error"
                     role="alert">
                  <span class="glyphicon glyphicon-exclamation-sign"
                        aria-hidden="true"></span>
                  <span class="sr-only">Error:</span> {{error }}
                </div>
              </div>
            </div>
            <div class="row sm-padding-top">
              <div class="col-md-6">
                <label for="name2">Name</label>
                <input pInputText
                       id="name2"
                       [(ngModel)]="facilityUser.name" />
              </div>
              <div class="col-md-6">
                <label for="tagLine">Account Type</label>
                <p-dropdown [style]="{'width':'100%'}"
                            [options]="facilityUserAccountTypes.types"
                            [(ngModel)]="facilityUser.accountType"></p-dropdown>
                <!--<input pInputText id="accountType" [(ngModel)]="facilityUser.accountType" />-->
              </div>
            </div>
            <div class="row sm-padding-top">
              <div class="col-md-12">
                <label for="facilities">Facilities</label>
                <p-multiSelect id="facilities"
                               [options]="facilities"
                               (onChange)="getLocationKeys(facilityUser.facilityKeys)"
                               [(ngModel)]="facilityUser.facilityKeys"></p-multiSelect>
              </div>
            </div>
            <div class="row sm-padding-top"
                 *ngIf="locations.length > 0">
              <div class="col-md-12">
                <label for="locations">Locations</label>
                <p-multiSelect id="locations"
                               [options]="locations"
                               [(ngModel)]="facilityUser.locationKeys"></p-multiSelect>
              </div>
            </div>
            <div class="row sm-padding-top">
              <div class="col-md-6">
                <label for="email">Email</label>
                <input pInputText
                       id="email"
                       [(ngModel)]="facilityUser.email" />
              </div>
              <div class="col-md-6">
                <label for="initialPassword">Initial Password</label>
                <input pInputText
                       id="initialPassword"
                       [disabled]="!isNew"
                       [(ngModel)]="facilityUser.initialPassword" />
              </div>
            </div>
            <div class="row sm-padding-top">
              <div class="col-md-6">
                <label for="jobTitle">Job Title</label>
                <input pInputText
                       id="jobTitle"
                       [(ngModel)]="facilityUser.jobTitle" />
              </div>
              <div class="col-md-6">
                <label for="phone">Phone</label>
                <p-inputMask id="phone"
                             mask="(***) ***-****"
                             [(ngModel)]="facilityUser.phone"></p-inputMask>
              </div>
            </div>
          </div>
          <p-footer class="margin-top">
            <div class="ui-dialog-buttonpane ui-helper-clearfix">
              <button type="button"
                      class="btn btn-accent"
                      (click)="saveFacilityUser()"><i class="fa fa-check"
                   aria-hidden="true"></i> Save</button>
            </div>
          </p-footer>
        </p-dialog>

      </div>
    </div>
  </md-card>
</div>
<ng-template #loading>
  <md-spinner color="primary"></md-spinner>
</ng-template>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/portal-home/portal-home.component.html